export const formatDateTime = (dateStr?: string | null) => {
    if (!dateStr) return '—';
    return new Date(dateStr).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
};

export const formatRelative = (dateStr?: string | null) => {
    if (!dateStr) return '—';
    const diffMs = Date.now() - new Date(dateStr).getTime();
    const minutes = Math.round(diffMs / 60_000);
    if (minutes < 1) return 'just now';
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.round(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    return `${Math.round(hours / 24)}d ago`;
};

export const formatMoney = (value?: string | number | null) => {
    const num = Number(value ?? 0);
    if (!Number.isFinite(num)) return '$0.00';
    return num.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

/** Money with an explicit sign, for deltas. */
export const formatSignedMoney = (value?: string | number | null) => {
    const num = Number(value ?? 0);
    if (!Number.isFinite(num) || num === 0) return formatMoney(0);
    return `${num > 0 ? '+' : '−'}${formatMoney(Math.abs(num))}`;
};

export const formatGb = (mb?: number | null) => {
    if (mb === null || mb === undefined) return '—';
    return `${(mb / 1024).toFixed(1)} GB`;
};
